import 'slick-carousel';
import { playFromActiveSlide } from '../modules/autoplay-video';

// Slider Book
const initSliderBook = () => {
	const $slider = $('.js-slider-book');

	const config = {
		swipeToSlide: true,
		dots: false,
		arrows: true,
		infinite: true,
	};

	if (!$slider.hasClass('slick-initialized')) {
		// Paging. Example: 1/6
		var $pagingContainer = $slider.parent().parent().find('.js-slider-paging');

		$slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			var i = (currentSlide ? currentSlide : 0) + 1;
			var $currentSlide = $pagingContainer.find('li:first-child').text(i);
			var $slideCount = $pagingContainer.find('li:last-child').text(slick.slideCount);
		});

		$slider.slick(config);
	}
};

// Slider Timeline
const initSliderTimeline = () => {
	const $slider = $('.js-slider-timeline');

	const config = {
		swipeToSlide: true,
		dots: false,
		arrows: true,
		infinite: true,
		asNavFor: '.js-slider-timeline-years',
	};

	if (!$slider.hasClass('slick-initialized')) {
		$slider.slick(config);
	}
};

// Slider Timeline Years
const initSliderTimelineYears = () => {
	const $slider = $('.js-slider-timeline-years');

	const config = {
		slidesToShow: 5,
		slidesToScroll: 1,
		centerMode: true,
		swipeToSlide: true,
		dots: false,
		arrows: false,
		infinite: true,
		asNavFor: '.js-slider-timeline',
		focusOnSelect: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
					arrows: false,
				},
			},
		],
	};

	if (!$slider.hasClass('slick-initialized')) {
		$slider.slick(config);
	}
};

// Slider Product Gallery
const initSliderProductGallery = () => {
	const $slider = $('.js-slider-product-gallery');

	const config = {
		slidesToShow: 3,
		slidesToScroll: 1,
		swipeToSlide: true,
		dots: true,
		arrows: true,
		infinite: true,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true,
					arrows: false,
				},
			},
		],
	};

	if (!$slider.hasClass('slick-initialized')) {
		// Paging. Example: 1/6
		var $pagingContainer = $slider.parent().parent().find('.js-slider-paging');

		$slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			var i = (currentSlide ? currentSlide : 0) + 1;
			var $currentSlide = $pagingContainer.find('li:first-child').text(i);
			var $slideCount = $pagingContainer.find('li:last-child').text(slick.slideCount);
		});

		$slider.slick(config);
		$slider.slick('setPosition');
	}
};

// Slider Story
const initSliderStory = () => {
	const $slider = $('.js-slider-story');

	const config = {
		swipeToSlide: true,
		dots: true,
		arrows: true,
		infinite: false,
		slidesToShow: 1,
		centerMode: true,
		variableWidth: true,
	};

	if (!$slider.hasClass('slick-initialized')) {
		// Paging. Example: 1/6
		var $pagingContainer = $slider.parent().parent().find('.js-slider-paging');

		$slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
			var i = (currentSlide ? currentSlide : 0) + 1;
			var $currentSlide = $pagingContainer.find('li:first-child').text(i);
			var $slideCount = $pagingContainer.find('li:last-child').text(slick.slideCount);
		});

		$slider.slick(config);
	}
};

const initSliderSwatches = () => {
	const $slider = $('.js-slider-swatches');
	const config = {
		slidesToShow: 1,
		slidesToScroll: 1,
		swipeToSlide: true,
		dots: true,
		arrows: false,
		infinite: false,
		variableWidth: true,
	};

	if ($(window).width() < 768) {
		$slider.not('.slick-initialized').slick(config);
	} else {
		$('.js-slider-swatches.slick-initialized').slick('unslick');
	}
};

const initProductSlider = (slider, thumbs) => {
	const sliderConfig = {
		slidesToShow: 1,
		slidesToScroll: 1,
		swipeToSlide: true,
		dots: true,
		arrows: true,
		infinite: false,
		asNavFor: thumbs,
		appendDots: $(slider).parent().find('.js-slider-product-dots'),
	};

	const thumbsConfig = {
		slidesToShow: 8,
		slidesToScroll: 8,
		swipeToSlide: true,
		dots: false,
		arrows: false,
		infinite: false,
		asNavFor: slider,
		focusOnSelect: true,
		variableWidth: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 5,
					variableWidth: true,
				},
			},
		],
	};

	$(slider)
		.on('init', function (slick) {
			const $countHolder = $(slider).parent().find('.js-slider-product-count');

			$countHolder.text(`1/${$(slider).find('.slick-slide').length}`);
		})
		.on('afterChange', function (event, slick, currentSlide, nextSlide) {
			const $countHolder = $(slider).parent().find('.js-slider-product-count');

			$countHolder.text(`${currentSlide + 1}/${slick.slideCount}`);
		})
		.not('.slick-initialized')
		.slick(sliderConfig);

	$(thumbs).not('.slick-initialized').slick(thumbsConfig);
};

const initPostsSlider = () => {
	const $sliders = $('.js-slider-product-posts');
	$sliders.each((index, slider) => {
		const $slider = $(slider);
		const config = {
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			dots: true,
			arrows: false,
			infinite: false,
			appendDots: $slider.parent().find('.js-section-posts-dots'),
		};

		$slider.not('.slick-initialized').slick(config);
	})
};

/**
 * Equalize the product sliders slides height
 * @param  {jQ Object} $slider The slider
 * @return {Void}
 */
const calcSlidesHeight = ($slider) => {
	const height = $slider.find('.slick-track').height();
	$slider.find('.slick-slide').css('height', `${height}px`);
};

/**
 * Initialize the products sliders
 * @param  {jQ Object} $skipElement Element to skip initializing
 * @return {Void}
 */
export const productsSliderInit = ($skipElement) => {
	$('.js-slider-products').each(function () {
		const $slider = $(this);
		const config = {
			swipeToSlide: true,
			infinite: $slider.data('infinite'),
			centerMode: true,
			variableWidth: true,
			outerEdgeLimit: true,
			arrows: true,
			dots: true,
			appendArrows: $slider.parent().find('.js-slider-products-nav'),
			appendDots: $slider.parent().find('.js-slider-products-dots'),
		};

		$slider
			.on('init', function (slick) {
				const $countHolder = $slider.parent().find('.js-slider-products-count');

				$countHolder.text(`1/${$slider.find('.slick-slide').not('.slick-cloned').length}`);

				calcSlidesHeight($slider);
			})
			.on('afterChange', function (event, slick, currentSlide, nextSlide) {
				const $countHolder = $slider.parent().find('.js-slider-products-count');

				$countHolder.text(`${currentSlide + 1}/${slick.slideCount}`);
			})
			.not('.slick-initialized')
			.not($skipElement)
			.slick(config);
	});
};

/**
 * Initialize autoplay videos slider
 * @return {Void}
 */
const initVideosSlider = () => {
	const $sliders = $('.js-slider-videos');
	$sliders.each((index, slider) => {
		const $slider = $(slider);
		const config = {
			slidesToShow: 1,
			slidesToScroll: 1,
			initialSlide: 1,
			dots: false,
			arrows: true,
			prevArrow: $slider.parent().find('.js-slider-actions .slider__prev'),
			nextArrow: $slider.parent().find('.js-slider-actions .slider__next'),
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 1023,
					settings: "unslick"
				}
			]
		}

		$slider.on('init', (slick) => {
			$slider.find('.slick-active').addClass('is-ready');
			playFromActiveSlide();
		})

		$slider.on('afterChange', (slick, currentSlide) => {
			const activeVideo = playFromActiveSlide() || null;
			$slider.find('.is-ready').removeClass('is-ready');
			if (activeVideo !== null) {
				activeVideo
					.parentsUntil('.slick-slide')
					.last()
					.parent()
						.addClass('is-ready');
				return;
			}

			$slider
				.find('.slick-active')
					.addClass('is-ready');
		})

		$slider
			.not('.slick-initialized')
			.slick(config)
	})
}

/**
 * Initialize featured split image sslider
 * @return {Void}
 */

const initFeaturedSplitImagesSlider = () => {
	const $sliders = $('.js-slider-images-with-text');
	$sliders.each((index, slider) => {
		const $slider = $(slider);
		const config = {
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '25%',
			dots: false,
			arrows: true,
			prevArrow: $slider.parent().find('.js-slider-actions .slider__prev'),
			nextArrow: $slider.parent().find('.js-slider-actions .slider__next'),
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						centerPadding: '17.5%',
					}
				},
				{
					breakpoint: 768,
					settings: {
						centerPadding: '10%',
						arrows: false
					}
				}
			]
		};

		$slider
			.not('.slick-initialized')
			.slick(config)
	})

}

/**
 * Initialize offset image sslider
 * @return {Void}
 */

 const initOffsetImageSlider = () => {
	const $sliders = $('.js-offset-carousel');
	$sliders.each((index, slider) => {
		const $slider = $(slider);
		const config = {
			slidesToShow: 1,
			initialSlide: 1,
			arrows: true,
			prevArrow: $slider.parent().find('.js-slider-actions .slider__prev'),
			nextArrow: $slider.parent().find('.js-slider-actions .slider__next'),
			dots: false,
			centerMode: true,
			centerPadding: '6%',
			infinite: true,
			speed: 400,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						centerPadding: '7.3%',
						arrows: false
					}
				}
			]
		};

		$slider
			.not('.slick-initialized')
			.slick(config)

		// Grabbing animation
		let isGrabbed = false;
		$slider.parent().on('mousedown touchstart', (e) => {
			isGrabbed = true;
			$slider.find('.slider__slide').addClass('is-grabbed');
		})

		$slider.parent().on('mouseup touchend', (e) => {
			if (!isGrabbed) {
				return;
			}
			isGrabbed = false;
			$slider.find('.slider__slide').removeClass('is-grabbed');
		})
	})
}

productsSliderInit($('.js-section-related-products .js-slider-products, .js-product-related-products .js-slider-products'));
initProductSlider('.js-slider-product', '.js-slider-product-thumbs');
initSliderSwatches();
initPostsSlider();
initSliderProductGallery();
initSliderStory();
initSliderTimeline();
initSliderTimelineYears();
initSliderBook();
initVideosSlider();
initFeaturedSplitImagesSlider();
initOffsetImageSlider();

$(window).on('shopify:section:load', function () {
	initProductSlider('.js-slider-product', '.js-slider-product-thumbs');
	initSliderSwatches();
	initPostsSlider();
	initSliderProductGallery();
	initSliderStory();
	initSliderTimeline();
	initSliderTimelineYears();
	initSliderBook();
	initVideosSlider();
	initFeaturedSplitImagesSlider();
	initOffsetImageSlider();
});

$(window).on('resize', function (event) {
	$('.js-slider-products').each(function () {
		const $slider = $(this);

		calcSlidesHeight($slider);
	});

	initSliderSwatches();
	initVideosSlider();
});
